<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Proveedores</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarProveedor">
                <i class="fa fa-plus"></i> Agregar Proveedor
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProveedor">
                <b-form-input
                  id="filtroProveedor"
                  type="text"
                  placeholder="Filtrar Proveedores"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables
                :data="data"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRow(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <editar-proveedor ref="refEditarProveedor" @actualizaProveedores="buscar()"></editar-proveedor>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarProveedor"
      @ok="eliminarProveedor();"
      @cancel="modalEliminarProveedor = false"
    >¿Está seguro que quiere desactivar este proveedor?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarProveedor"
      @ok="activarProveedor();"
      @cancel="modalActivarProveedor = false"
    >¿Está seguro que quiere activar este proveedor?</b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiProveedores from "@/components/services/apiProveedores";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import EditarProveedor from "./EditarProveedor";

export default {
  name: "Proveedores",
  mixins: [tablasMixin, globalesMixin],
  components: {
    cSwitch,
    EditarProveedor
  },
  data: function() {
    return {
      modalEliminarProveedor: false,
      modalActivarProveedor: false,
      modalAgregarProveedor: false,
      proveedorSelected: null,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      datosFormulario: [],
      data: [],
      titles: [
        {
          prop: "pricodigo",
          label: "Código"
        },
        {
          prop: "prinombre",
          label: "Nombre"
        },
        {
          prop: "pricodnum",
          label: "Código Sujeto"
        },
        {
          prop: "privadirec",
          label: "Dirección Privada"
        },
        {
          prop: "infinforme",
          label: "Tipo Informe"
        },
        {
          prop: "priusumodif",
          label: "Usuario Modificación"
        },
        {
          prop: "prifmodif",
          label: "Fecha Modificación"
        },
        {
          prop: "desc_activo",
          label: "Estado"
        }
      ],
      filters: [
        {
          prop: [
            "pricodigo",
            "prinombre",
            "pricodnum",
            "privadirec",
            "infinforme",
            "priusumodif",
            "prifmodif",
            "desc_activo"
          ],
          value: ""
        }
      ]
    };
  },
  methods: {
    customButtonsForRow(row) {
      if (row.priactivo === 0) {
        return [
          {
            name: " Activar",
            icon: "fa fa-plus",
            type: "success",
            handler: _ => {
              this.$session.start();
              this.modalActivarProveedor = true;
              this.proveedorSelected = row.pricodigo;
            }
          }
        ];
      } else {
        return [
          {
            name: " Modificar",
            icon: "fa fa-pencil",
            type: "primary",
            handler: _ => {
              this.$refs.refEditarProveedor.modalEditarProveedor = true;
              this.$refs.refEditarProveedor.visible = true;
              this.$refs.refEditarProveedor.obtenerProveedor(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                row.pricodigo,
                "MOD"
              );
            }
          },
          {
            name: " Desactivar",
            icon: "fa fa-trash",
            type: "danger",
            handler: _ => {
              this.$session.start();
              this.modalEliminarProveedor = true;
              this.proveedorSelected = row.pricodigo;
            }
          }
        ];
      }
    },
    buscar(p_pricodigo) {
      this.$Progress.start();

      return apiProveedores
        .buscar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_pricodigo,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$router.push({ path: "proveedores" });
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.$moment(row[column.property]).format("DD-MM-YYYY");
      } else if (column.property == "pricodnum" && row[column.property]) {
        column.align = "is-right";
        return this.$numeral(row[column.property]).format("0");
      } else {
        return row[column.property];
      }
    },
    agregarProveedor() {
      this.$refs.refEditarProveedor.modalAgregarProveedor = true;
      this.$refs.refEditarProveedor.visible = true;
      this.$refs.refEditarProveedor.pre_insertar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        ""
      );
    },
    eliminarProveedor() {
      event.preventDefault();
      this.$Progress.start();
      return apiProveedores
        .eliminar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.proveedorSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "pricodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalEliminarProveedor = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    activarProveedor() {
      event.preventDefault();
      this.$Progress.start();
      return apiProveedores
        .activar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.proveedorSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "pricodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalActivarProveedor = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.buscar("");
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
      this.$router.push({ path: "proveedores" });
    }
  }
};
</script>
